import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Services
import Vendor from 'services/data/vendor';

// Actions
import { alerts } from 'modules/alerts/actions';

// Components
import { SelectInput } from 'components/forms/form-elements';


export default class VendorSelect extends React.Component {
  static propTypes = {
    config: PropTypes.object
  };

  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    Vendor.find(Vendor.defaultQuery)
      .then((vendors) => {
        this.setState({ vendors: _.map(vendors, vendor => ({ label: vendor, value: vendor })) });
      })
      .catch(alerts.catchError);
  }

  render() {
    return (
      <SelectInput
        {...this.props}
        valueKey="label"
        labelKey="value"
        isLoading={!this.state.vendors}
        options={this.state.vendors}
        creatable
      />
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/forms/selects/vendor-select.js